import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-prev-page",
  "use": "icon-prev-page-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-prev-page\">\n  <defs>\n    <style type=\"text/css\"></style>\n  </defs>\n  <path d=\"M896 512a384 384 0 1 0-384 384 384 384 0 0 0 384-384z m64 0A448 448 0 1 1 512 64a448 448 0 0 1 448 448z\" p-id=\"2735\" />\n  <path d=\"M598.72 713.28a32 32 0 0 1-45.44 45.44l-224-224a32 32 0 0 1 0-45.44l224-224a32 32 0 0 1 45.44 45.44L397.12 512z\" p-id=\"2736\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol